import { render, staticRenderFns } from "./NewWebsiteCategory.vue?vue&type=template&id=33fcfe5e&scoped=true&"
import script from "./NewWebsiteCategory.vue?vue&type=script&lang=js&"
export * from "./NewWebsiteCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fcfe5e",
  null
  
)

export default component.exports